<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">{{ $t('payment_success') }} support@{{ $parent.hostname }}</div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  name: 'PaymentSuccessPage',
  props: [],
  components: {
  },
  data: function () {
    return {

    }
  },
  methods: {

  },
  mounted() {
    this.$emit('paymentSuccess');
  }
}
</script>